import { useMemo } from "react"
import CardOptionStyled from "@Components/Summary/SummaryOption/CardOption.styled"
import { abbreviateNumber } from "@Helpers/UtilsHelper"
import { IMenu } from "@Interfaces/IMenu"
import { IconArrowRigth, IconSpinner } from "@Theme/common/Icon.styled"

const CardOption = ({ icon, optionCount, title, path, stateLocation }: IMenu) => {
  const countAbbreviate = useMemo(() => abbreviateNumber(optionCount || 0), [optionCount])
  return (
    <CardOptionStyled
      to={{
        pathname: path,
        state: stateLocation,
      }}
    >
      <div className="section-count">
        <div className="icon-option">{icon}</div>
        <p className="option-count">
          {optionCount === undefined ? <IconSpinner variant="big" /> : countAbbreviate}
        </p>
      </div>
      <div className="section-title">
        <p className="option-name">{title}</p>
        <IconArrowRigth className="icon-arrow" />
      </div>
      {/* <mark>99</mark> */}
    </CardOptionStyled>
  )
}

export default CardOption
